import React from 'react';
import { COLORS } from '../../../styles/tokens';
import NewOrderIcon from './NewOrderIcon';
import { activeMassTypes, useMassCatalog } from '../../../utils/massCatalog';

// Massetype som fliser (3 per rad). Valgt = marineblå med gull ikon. Typene kommer fra massekatalogen.
// allowedKeys: null/undefined = alle valgbare; ellers vises typer utenfor listen nedtonet og kan ikke velges.
// excludeKeys: typer som ikke vises i det hele tatt.
export default function MassTiles({ value, onChange, allowedKeys = null, excludeKeys = [] }) {
  useMassCatalog();
  const options = activeMassTypes().filter(o => !excludeKeys.includes(o.key));
  return (
    <div role="group" aria-label="Massetype" style={{ display: 'grid', gridTemplateColumns: 'repeat(3, 1fr)', gap: 8 }}>
      {options.map(o => {
        const on = value === o.key;
        const blocked = allowedKeys != null && !allowedKeys.includes(o.key);
        return (
          <button
            key={o.key}
            type="button"
            aria-pressed={on}
            aria-disabled={blocked || undefined}
            onClick={() => { if (!blocked) onChange(o.key); }}
            style={{
              height: 82, borderRadius: 16, cursor: blocked ? 'not-allowed' : 'pointer',
              opacity: blocked ? 0.4 : 1,
              display: 'flex', flexDirection: 'column', alignItems: 'center', justifyContent: 'center', gap: 6,
              background: on ? COLORS.brandPanel : COLORS.white,
              color: on ? '#fff' : COLORS.textDark,
              border: on ? '1px solid transparent' : `1px solid ${COLORS.border}`,
            }}
          >
            <span style={{ color: on ? COLORS.accent : COLORS.brandPanel, display: 'flex' }}>
              <NewOrderIcon name={o.icon} size={24} />
            </span>
            <span style={{ fontSize: 13, fontWeight: 700 }}>{o.label}</span>
          </button>
        );
      })}
    </div>
  );
}
